import React, { useState, useEffect } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import { fetchData, updateData, masterdataindex } from '../../../apiService';
import { faL } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Select from 'react-select';


const AssetEdit = ({ match }) => {
    const { id, Mtypeid } = useParams();
    const recordId = useParams();
    const history = useHistory();
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const { isAuthenticated, companyId, userId, logout, token } = useAuth();
    const [formData, setFormData] = useState({});
    const [selectedMaster, setSelectedMaster] = useState("");
    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        fetchIndexMasterType();
    }, [id, Mtypeid, isAuthenticated, token, logout]);

    const fetchIndexMasterType = async () => {
        try {

            const response = await fetchData('AccountHeadApi', `/CategoryEditData/${companyId}/${Mtypeid}`, token);
            if (response.responseCode === '1111') {
                const dataArray = response.response_data;
                setFormData(dataArray);
            }
        } catch (error) {
            console.error('Error fetching Sale Details:', error);
        }
    };


    //Balance Sheet


    const [balancesheetOptions, setBalanceSheetOptions] = useState([]);
    const [selectedBalanceSheetType, setSelectedBalanceSheetType] = useState("");

    const fetchBalanceSheet = async () => {
        try {
            const response = await fetchData('MasterApi', `/BalanceSheetData/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(balance => ({
                    value: balance.Id,
                    label: balance.Name
                }));
                setBalanceSheetOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };
    const handleBalanceSheetChange = (selectedOption) => {
        setSelectedBalanceSheetType(selectedOption);
    };

    useEffect(() => {
        fetchBalanceSheet();
    }, []);


    //MasterType


    const [MasterTypeOptions, setMasterTypeOptions] = useState([]);
    const [selectedMasterType, setSelectedMasterType] = useState("");
    const [selectedMasterTypeId, setSelectedMasterTypeId] = useState("");

    const fetchMasterType = async () => {
        try {
            // const response = await fetchData('MasterApi', `/${companyId}`, token);
            const response = await fetchData('MasterApi', `/MasterTypeData/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(master => ({
                    value: master.Id,
                    label: master.Name
                }));
                setMasterTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };
    const handleMasterTypeChange = (selectedOption) => {
        //setSelectedMasterType(selectedOption);
        setSelectedMasterType(selectedOption.label);
        setSelectedMasterTypeId(selectedOption.value);
    };

    useEffect(() => {
        fetchMasterType();
    }, []);

    //  Invoice Type

    const [InvoiceTypeOptions, setInvoiceTypeOptions] = useState([]);
    const [selectedInvoiceType, setSelectedInvoiceType] = useState("");

    const fetchInvoiceType = async () => {
        try {
            // const response = await fetchData('MasterApi', `/${companyId}`, token);
            const response = await fetchData('MasterApi', `/InvoiceTypeData/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(invoice => ({
                    value: invoice.Id,
                    label: invoice.Name
                }));
                setInvoiceTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };
    const handleInvoiceTypeChange = (selectedOption) => {
        //setSelectedMasterType(selectedOption);
        setSelectedInvoiceType(selectedOption);
    };

    useEffect(() => {
        fetchInvoiceType();
    }, []);

    // Branch Select for Staff Creation

    const [BranchTypeOptions, setBranchTypeOptions] = useState([]);
    const [selectedBranchType, setSelectedBranchType] = useState("");

    const fetchBranchType = async () => {
        try {
            // const response = await fetchData('MasterApi', `/${companyId}`, token);
            const response = await fetchData('BranchApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(branch => ({
                    value: branch.Id,
                    label: branch.Name
                }));
                setBranchTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };
    const handleBranchTypeChange = (selectedOption) => {
        //setSelectedMasterType(selectedOption);
        setSelectedBranchType(selectedOption);
    };

    useEffect(() => {
        fetchBranchType();
    }, []);


    const handleChange = (event) => {
        const { name, value, type } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? !prevData[name] : value,
        }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);

        setFormData(prevData => ({
            ...prevData,
            UpdatedBy: userId,
        }));

        // Validate form data here if needed

        updateData('CategoryApi', `${id}`, formData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                history.push('/ItemIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
                setIsLoading(false);
            });
    };

    return (
        <div className="w-full max-w-sm container mt-2 mx-auto">
            <form onSubmit={handleSubmit}>
                <div className="w-full mb-2 flex">
                    <h4 className="productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}>
                        Variant - Edit
                    </h4>

                    <Tooltip title="Exit">
                        <Link to="/ItemIndex" style={{ color: 'red', textDecoration: 'none', fontWeight: 'bolder' }}>
                            <Button style={{ color: 'red', fontWeight: 'bolder' }}>
                                Exit <ExitToAppIcon />
                            </Button>
                        </Link>
                    </Tooltip>

                    <Tooltip title="SAVE">
                        <Button onClick={handleSubmit} style={{ color: 'darkolivegreen', fontWeight: 'bolder', marginLeft: '2px' }} disabled={isLoading}>
                            {isLoading ? <CircularProgress size={24} color="inherit" /> : "UPDATE"} <CheckCircleIcon />
                        </Button>
                    </Tooltip>
                </div>

                {/* Display success and error messages */}
                {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                {successMessage && <p className="text-green-500">{successMessage}</p>}

                <div className="fixed inset-0 flex items-center justify-center z-10">
                    <div className="bg-black p-6 rounded-lg shadow-lg" style={{ width: '1100px' }}>
                        <h6>MasterEdit</h6>

                        <div className="w-full mb-4 flex">
                            <div className="w-1/3 mr-2">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="balanceSheet">
                                    Balance Sheet
                                </label>
                                <Select
                                    value={selectedBalanceSheetType}
                                    onChange={handleBalanceSheetChange}
                                    options={balancesheetOptions}
                                    placeholder="Balance sheet"
                                    isSearchable
                                />
                            </div>

                            <div className="w-1/4 mr-2" style={{ width: '80%' }}>
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name">
                                    Name
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    type="text"
                                    name="Name"
                                    placeholder="Enter Name"
                                    value={formData.name}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="w-1/4 mr-2" style={{ width: '80%' }}>
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="searchableName">
                                    Searchable Name
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    type="text"
                                    name="searchablename"
                                    placeholder="Enter Searchable Name"
                                    value={formData.searchablename}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="w-full mb-4 flex">
                            <div className="w-full mr-2">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="remarks">
                                    Remarks
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    type="text"
                                    name="remarks"
                                    placeholder="Enter Remarks"
                                    value={formData.remarks}
                                    onChange={handleChange}
                                    style={{ width: '100%' }}
                                />
                            </div>

                            <div className="w-1/3 mr-2">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="masterType">
                                    Master Type
                                </label>
                                <Select
                                    value={MasterTypeOptions.find(option => option.label === selectedMasterType)}  // Match the selected option by label
                                    onChange={handleMasterTypeChange}
                                    options={MasterTypeOptions}
                                    placeholder="Master Type"
                                    isSearchable
                                />
                            </div>
                        </div>

                        {/* Capital */}
                        {/* {Mtypeid === 1 && (
                            <> */}
                        <div className="w-full mb-4 flex">
                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-green-700 text-xs font-bold mb-2" htmlFor="ContactNumber1">
                                    Contact Number 1
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    type="text"
                                    placeholder="Contact Number 1"
                                    value={formData.ContactNumber1}
                                    onChange={handleChange}
                                    id="ContactNumber1"
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-green-700 text-xs font-bold mb-2" htmlFor="ContactNumber2">
                                    Contact Number 2
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    type="text"
                                    placeholder="Contact Number 2"
                                    value={formData.ContactNumber2}
                                    onChange={handleChange}
                                    id="ContactNumber2"
                                />
                            </div>

                            <div className="w-1/2 mr-2">
                                <label className="block uppercase tracking-wide text-green-700 text-xs font-bold mb-2" htmlFor="Email">
                                    Email
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    type="text"
                                    placeholder="Email"
                                    value={formData.Email}
                                    onChange={handleChange}
                                    id="Email"
                                />
                            </div>
                        </div>

                        <div className="w-full mb-4 flex">
                            <div className="w-1/2 mr-2">
                                <label className="block uppercase tracking-wide text-green-700 text-xs font-bold mb-2" htmlFor="AddressLine1">
                                    Address Line 1
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    type="text"
                                    placeholder="Address Line 1"
                                    value={formData.AddressLine1}
                                    onChange={handleChange}
                                    id="AddressLine1"
                                />
                            </div>

                            <div className="w-1/2 mr-2">
                                <label className="block uppercase tracking-wide text-green-700 text-xs font-bold mb-2" htmlFor="AddressLine2">
                                    Address Line 2
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    type="text"
                                    placeholder="Address Line 2"
                                    value={formData.AddressLine2}
                                    onChange={handleChange}
                                    id="AddressLine2"
                                />
                            </div>
                        </div>
                        {/* </>
                        )} */}
                    </div>
                </div>
            </form>
        </div>
    );

};

export default AssetEdit;
